'use client';
import React, { useEffect } from 'react';
import Script from 'next/script';

function StoreLocator({ position }) {
  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://widget.storepoint.co/embed.js"]'
    );
    if (window.StorepointWidget !== undefined && existingScript) {
      try {
        const storepoint = new window.StorepointWidget(
          '168933e504b622',
          '#storepoint-widget',
          {}
        );
        storepoint?.load();
      } catch (e) {
        console.warn(e);
      }
    }
  }, []);

  return (
    <section id={`store-locator-${position}`} className="p-0">
      <div id="storepoint-widget" data-cy="storepoint-container"></div>
      <Script
        id="storepoint-script"
        data-cy="storepoint-script"
        dangerouslySetInnerHTML={{
          __html: `window.loadStorepoint=function(){
    var storepoint = new StorepointWidget(
        '168933e504b622',
        '#storepoint-widget',
        {}
    );
};!function(){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://widget.storepoint.co/embed.js";t.onload=function(){"function"==typeof window.loadStorepoint&&window.loadStorepoint()};document.head.appendChild(t);}();`
        }}
      />
    </section>
  );
}

export default StoreLocator;
